import React from 'react';
import { Button, DatePicker, Modal, Select } from 'components';
import { UserService } from 'services';
import { Constants, Globals } from 'utils';
import moment from 'moment';
import SearchAffiliate from './search-affiliate';
import { CreatePaymentForm, CreatePaymentPlan, CreatePaymentProps, CreatePaymentState } from './modal-create.entity'

class CreatePaymentZelle extends React.Component<CreatePaymentProps, CreatePaymentState> {
	state = {
		form: {
			payment_id: null,
			plan_id: null,
			user_id: null,
			affiliate_type: null,
			seller_code: '',
			payment_method_id: Constants.PAYMENT_METHODS.ZELLE,
			frequency: undefined,
			currency: Constants.CURRENCIES.USD,
			plan_payment_id: null,
			// Pago móvil
			payment_phone: '',
			payment_document: '',
			bank_id: undefined,
			payment_date: '',
			reference: '',
			// Zelle
			payment_name: '',
			payment_email: '',
		},
		// Nuevos estados para la búsqueda
		searchQuery: '',
		isSearching: false,
		selectedUser: null as any,
		searchError: '',
		submitting: false,
		plans: [],
		banks: [],
	};

	componentDidMount(): void {
		this.getSelects();
		if (this.props.item) this.fillForm();
	};

	getSelects = async () => {
		try {
			const res: any = await UserService.admin.getSelects();
			this.setState({
				plans: res.plans?.map((i: any) => ({
					value: i.id,
					label: i.name,
					affiliate_type: i.affiliate_type,
				})),
			});

		} catch (error) {
			console.log(error)
		}
	};

	fillForm = () => {
		const { item } = this.props;

		this.setState(s => ({
			form: {
				...s.form,
				payment_id: item.id,
				plan_id: item?.plan_user?.plan_id,
				user_id: item?.plan_user?.user_id,
				affiliate_type: item?.plan_user?.user?.affiliate_type,
				frequency: item.frequency,
				payment_date: moment(item?.date).toDate(),
				reference: item?.reference,
				payment_name: item?.name,
				payment_email: item?.email,
			},
		}));
	}

	change = (value: any, target: keyof CreatePaymentForm) => {
		this.setState(s => ({ ...s, form: { ...s.form, [target]: value } }));
	};

	changeUser = async (user: any) => {
		this.change(user.id, 'user_id');
		this.change(user.affiliate_type, 'affiliate_type');
		this.change('', 'plan_id');
	};

	isValidForm = (showError: boolean = true) => {
		const onError = (msg: string) => {
			if (showError) Globals.showError(msg);
			return false;
		}

		const { form } = this.state;

		if (!form.user_id)
			return onError('Debe seleccionar un usuario');

		if (!form.payment_name)
			return onError('Debe indicar el nombre del titular');

		if (!form.payment_email)
			return onError('Debe indicar el correo electrónico');

		if (!form.payment_date)
			return onError('Debe indicar la fecha de pago');

		if (!form.reference)
			return onError('Debe indicar la referencia');

		if (!form.plan_id)
			return onError('Debe seleccionar un plan');

		if (!form.frequency)
			return onError('Debe seleccionar una frecuencia');

		return true;
	};

	submit = async (e: any) => {
		e.preventDefault();
		if (!this.isValidForm() || this.state.submitting) return;

		this.setState({ submitting: true });
		try {
			const payload = {
				...this.state.form,
				payment_date: moment(this.state.form.payment_date).isValid() ? moment(this.state.form.payment_date).format('YYYY-MM-DD') : null,
			};

			await UserService.admin.createPayment(payload);
			this.props.onSuccess();

		} catch (error) {
			console.log(error)
		} finally {
			this.setState({ submitting: false });
		}
	};

	render() {
		const { form, submitting } = this.state;

		return (
			<Modal
				className="modal-create-notification"
				visible
				onClose={this.props.onClose}
			>
				<div id="modal-create-payment">
					<h3>Registrar Pago - Zelle</h3>

					<form onSubmit={this.submit}>
						<SearchAffiliate item={this.props?.item?.plan_user?.user} onSelectUser={this.changeUser} />

						<div>
							<label>Nombre del titular</label>
							<input
								type="text"
								className="form-control"
								value={form.payment_name}
								onChange={e => this.change(e.target.value, 'payment_name')}
							/>
						</div>

						<div>
							<label>Correo</label>
							<input
								type="text"
								className="form-control"
								value={form.payment_email}
								onChange={e => this.change(e.target.value, 'payment_email')}
							/>
						</div>

						<div className="dual">
							<DatePicker
								label="Fecha de pago"
								value={form.payment_date}
								onChange={(value: any) => this.change(value, 'payment_date')}
							/>

							<div>
								<label>Referencia</label>
								<input
									type="text"
									className="form-control"
									value={form.reference}
									onChange={e => this.change(e.target.value, 'reference')}
								/>
							</div>
						</div>

						<Select
							label="Plan"
							name="plan_id"
							placeholder="Seleccione"
							value={form.plan_id}
							onChange={e => this.change(e.target.value, 'plan_id')}
							options={this.state.plans.filter((i: CreatePaymentPlan) => i.affiliate_type === form.affiliate_type)}
						/>

						<div>
							<label>Frecuencia</label>
							<div className="frequency">
								<RadioItem
									label="Mensual"
									isActive={form.frequency === Constants.FREQUENCY.MONTHLY}
									onClick={() => this.change(Constants.FREQUENCY.MONTHLY, 'frequency')}
								/>
								<RadioItem
									label="Trimestral"
									isActive={form.frequency === Constants.FREQUENCY.QUARTERLY}
									onClick={() => this.change(Constants.FREQUENCY.QUARTERLY, 'frequency')}
								/>
								<RadioItem
									label="Semestral"
									isActive={form.frequency === Constants.FREQUENCY.SEMESTER}
									onClick={() => this.change(Constants.FREQUENCY.SEMESTER, 'frequency')}
								/>
								<RadioItem
									label="Anual"
									isActive={form.frequency === Constants.FREQUENCY.ANNUAL}
									onClick={() => this.change(Constants.FREQUENCY.ANNUAL, 'frequency')}
								/>
							</div>
						</div>

						<div className="actions">
							<Button type="button" onClick={this.props.onClose}>
								Cerrar
							</Button>
							<Button type="submit" disabled={!this.isValidForm(false) || submitting}>
								Guardar
							</Button>
						</div>
					</form>
				</div>
			</Modal>
		);
	}
}

interface RadioItemProps {
	label: string;
	isActive: boolean;
	onClick: () => void;
}

const RadioItem = ({ label, isActive, onClick }: RadioItemProps) => {
	return (
		<div className="radio-item" onClick={onClick}>
			<div data-active={String(Boolean(isActive))} />
			<label>{ label }</label>
		</div>
	)
}

export default CreatePaymentZelle;